// extracted by mini-css-extract-plugin
export default {"base":"MiniButton_base__xGgMf","blue":"MiniButton_blue__mXcbF","red":"MiniButton_red__vSOb7","gray":"MiniButton_gray__muPHf","disabled":"MiniButton_disabled__s5qaF"};